// Panel de RRHH recursos humanos
import { useState, useEffect } from 'react';
import { db} from '../firebase/config'
import { 
    collection, query, where, doc, deleteDoc,addDoc, updateDoc, onSnapshot, Timestamp,
    arrayUnion, or
} from 'firebase/firestore';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { calculateVacationBalance, formatDate, calculateBusinessDays} from '../utils/helpers'
import { VacationRequestsTable } from '../components/shared/VacationRequestsTable'
import {WeeklyAttendanceUpload} from '../components/Admin/WeeklyAttendanceUpload'

export const HRDashboard = () => {
    const [employees, setEmployees] = useState([]);
    const [vacationRequests, setVacationRequests] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editData, setEditData] = useState({ 
        fecha: '', 
        acumulados: 0, 
        tomadosManual: 0 
    });
    const [historyModalEmployee, setHistoryModalEmployee] = useState(null);
    const [loadingEmployees, setLoadingEmployees] = useState(true);
    const [holidays, setHolidays] = useState([]);
    const [showHolidaysModal, setShowHolidaysModal] = useState(false);
    const [scheduleModalEmployee, setScheduleModalEmployee] = useState(null);
    const [view, setView] = useState('dashboard');

    useEffect(() => {
        setLoadingEmployees(true);

        const qUsers = query(collection(db, "usuarios")); 
        
        const unsubscribeUsers = onSnapshot(qUsers, (snapshot) => {
            const usersData = snapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(user => {
                    const sensitiveRoles = ['administrador', 'directivo', 'rh', 'cliente'];
                    
                    if (sensitiveRoles.includes(user.rol)) return false;

                    if (user.roles && user.roles.some(r => sensitiveRoles.includes(r))) return false;

                    return true;
                });
            
            setEmployees(usersData);
            setLoadingEmployees(false);
        }, (error) => {
            console.error("Error fetching employees:", error);
            toast.error("Error de seguridad al cargar empleados.");
            setLoadingEmployees(false);
        });

        const qRequests = query(
            collection(db, "solicitudesVacaciones"),
            or(
                where("estado", "==", "Pendiente RH"),
                where("estado", "==", "Pendiente Supervisor")
            )
        );

        const unsubscribeRequests = onSnapshot(qRequests, (snapshot) => {
            const allPending = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            const visibleToRH = allPending.filter(req => 
                req.estado === 'Pendiente RH' || 
                (req.estado === 'Pendiente Supervisor' && req.rol === 'supervisor')
            );
            setVacationRequests(visibleToRH);
        });

        const qHolidays = query(collection(db, "diasFestivos"));
        const unsubscribeHolidays = onSnapshot(qHolidays, (snapshot) => {
            const loadedHolidays = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));    
            setHolidays(loadedHolidays);
        });

        return () => {
            unsubscribeUsers();
            unsubscribeRequests();
            unsubscribeHolidays();
        };
    }, []);

    const handleSaveData = async (userId) => {
        if(!userId) return;
        
        try {
            const userRef = doc(db, "usuarios", userId);
            const updatePayload = {
                diasAcumuladosAnteriores: Number(editData.acumulados) || 0,
                diasTomadosManuales: Number(editData.tomadosManual) || 0
            };
            
            if (editData.fecha) {
                const newDate = new Date(editData.fecha + 'T12:00:00');
                if(!isNaN(newDate.getTime())) {
                     updatePayload.fechaIngreso = Timestamp.fromDate(newDate);
                } else {
                    toast.warning("Fecha inválida, no se actualizó la fecha.");
                }
            }
            
            await updateDoc(userRef, updatePayload);
            setEditingId(null);
            toast.success("Datos de empleado actualizados correctamente.");
        } catch (error) {
            console.error("Error updating employee:", error);
            toast.error("Error al actualizar: Verifique permisos.");
        }
    };

    const startEditing = (emp) => {
        setEditingId(emp.id);
        const dateStr = emp.fechaIngreso ? emp.fechaIngreso.toDate().toISOString().split('T')[0] : '';
        setEditData({
            fecha: dateStr,
            acumulados: emp.diasAcumuladosAnteriores || 0,
            tomadosManual: emp.diasTomadosManuales || 0
        });
    };

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-900">Gestión de Recursos Humanos</h1>
            <div className="mb-6 border-b border-gray-200">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    <button onClick={() => setView('dashboard')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'dashboard' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Gestion de empleados
                    </button>
                    <button onClick={() => setView('checadas')} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${view === 'checadas' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'}`}>
                        Checadas
                    </button>
                </nav>
            </div>
            {view === 'dashboard' && (
                <div>
                    <div className="flex justify-between items-center mb-6">
                        <button 
                            onClick={() => setShowHolidaysModal(true)}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow flex items-center gap-2"
                        >
                            Gestionar Festivos
                        </button>
                    </div>
                    <div className="mb-8">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">Solicitudes Pendientes</h2>
                        <VacationRequestsTable requests={vacationRequests} viewerRole="rh" onActionComplete={() => {}} />
                    </div>
                    <div className="bg-white rounded-xl shadow overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
                            <h2 className="text-lg font-semibold text-gray-700">Nómina de Empleados</h2>
                            {loadingEmployees && <span className="text-sm text-blue-600">Actualizando...</span>}
                        </div>
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Empleado</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha Ingreso / Ajustes</th>
                                        <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase bg-green-50">Saldo Disponible</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {employees.map(emp => {
                                        const balance = calculateVacationBalance(emp.fechaIngreso, emp.historialVacaciones || []);
                                        const ajusteManual = (emp.diasAcumuladosAnteriores || 0) - (emp.diasTomadosManuales || 0);
                                        const saldoFinal = balance.disponibles + ajusteManual;

                                        return (
                                            <tr key={emp.id} className="hover:bg-gray-50 transition-colors">
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-medium text-gray-900">{emp.nombreCompleto}</div>
                                                    <div className="text-xs text-gray-500">{emp.rol}</div>
                                                    <div className="text-xs text-gray-400">Antigüedad: {balance.antiguedad} años</div>
                                                </td>
                                                
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                                    {editingId === emp.id ? (
                                                        <div className="flex flex-col space-y-2 bg-yellow-50 p-2 rounded border border-yellow-200">
                                                            <div>
                                                                <label className="text-xs font-bold block">Ingreso:</label>
                                                                <input type="date" className="border rounded p-1 text-xs w-full" value={editData.fecha} onChange={(e) => setEditData({...editData, fecha: e.target.value})} />
                                                            </div>
                                                            <div className="flex space-x-2">
                                                                <div>
                                                                    <label className="text-xs font-bold block" title="Días extra/anteriores">Acum. (+)</label>
                                                                    <input type="number" className="border rounded p-1 text-xs w-16" value={editData.acumulados} onChange={(e) => setEditData({...editData, acumulados: e.target.value})} />
                                                                </div>
                                                                <div>
                                                                    <label className="text-xs font-bold block" title="Días tomados fuera del sistema">Manual (-)</label>
                                                                    <input type="number" className="border rounded p-1 text-xs w-16" value={editData.tomadosManual} onChange={(e) => setEditData({...editData, tomadosManual: e.target.value})} />
                                                                </div>
                                                            </div>
                                                            <div className="flex justify-end space-x-2 mt-1">
                                                                <button onClick={() => setEditingId(null)} className="text-red-600 text-xs font-bold px-2">Cancelar</button>
                                                                <button onClick={() => handleSaveData(emp.id)} className="bg-green-600 text-white text-xs font-bold px-2 py-1 rounded">Guardar</button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="group flex items-center space-x-2 cursor-pointer" onClick={() => startEditing(emp)}>
                                                            <span>{emp.fechaIngreso ? formatDate(emp.fechaIngreso) : '---'}</span>
                                                            <span className="text-gray-400 group-hover:text-blue-600">✏️</span>
                                                        </div>
                                                    )}
                                                </td>

                                                <td className="px-6 py-4 whitespace-nowrap text-center bg-green-50">
                                                    <div className="flex flex-col items-center">
                                                        <span className="text-lg font-bold text-green-700">
                                                            {emp.fechaIngreso ? Math.floor(saldoFinal) : '-'} 
                                                        </span>
                                                        
                                                        <span className="text-[10px] text-green-600">días disponibles</span>
                                                        <span className="text-[9px] text-gray-400 mt-1">
                                                            (Prop: {saldoFinal.toFixed(2)} dias)
                                                        </span>
                                                    </div>
                                                </td>

                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                                    <button 
                                                        onClick={() => setScheduleModalEmployee(emp)} 
                                                        className="text-orange-600 hover:text-orange-900 bg-orange-50 px-3 py-1 rounded-md border border-orange-200"
                                                    >
                                                        Horario
                                                    </button>
                                                    <button 
                                                        onClick={() => setHistoryModalEmployee(emp)} 
                                                        className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 px-3 py-1 rounded-md border border-indigo-200"
                                                    >
                                                        Bitácora
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>     
                </div>
            )}
            {view === 'checadas' && (
                <div>
                    <h2 className="text-2xl font-bold text-gray-800 my-6">📂 Procesar Asistencias Semanales</h2>
                     <WeeklyAttendanceUpload />
                </div>
            )}

                {historyModalEmployee && (
                    <EmployeeHistoryModal 
                    employee={historyModalEmployee} 
                    holidays={holidays}
                    onClose={() => setHistoryModalEmployee(null)} 
                    onUpdate={() => {}}
                    />
                )}

                {showHolidaysModal && (
                    <HolidaysManagementModal 
                        holidays={holidays}
                        onClose={() => setShowHolidaysModal(false)}
                    />
                )}

                {scheduleModalEmployee && (
                    <EmployeeScheduleModal 
                        employee={scheduleModalEmployee} 
                        onClose={() => setScheduleModalEmployee(null)} 
                    />
                )}
        </div>
    );
};

// historial de vacaciones de los empleados
const EmployeeHistoryModal = ({ employee, onClose, onUpdate, holidays }) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
    const history = (employee.historialVacaciones || []).sort((a, b) => 
        b.fechaInicio.seconds - a.fechaInicio.seconds
    );

    const handleAddManual = async () => {
        if (!startDate || !endDate) return alert("Fechas requeridas");
        
        const start = new Date(startDate + 'T12:00:00');
        const end = new Date(endDate + 'T12:00:00');
        const businessDays = calculateBusinessDays(start, end, holidays);

        if (end < start) return alert("La fecha fin no puede ser antes de la inicio");

        if (businessDays === 0) return alert("El rango seleccionado no tiene días hábiles.");

        setLoading(true);
        try {
            const userRef = doc(db, "usuarios", employee.id);
            
            const nuevoRegistro = {
                id: Date.now().toString(),
                fechaInicio: Timestamp.fromDate(start),
                fechaFin: Timestamp.fromDate(end),
                dias: businessDays,
                motivo: reason || "Registro Manual RH",
                tipo: "Manual (RH)",
                fechaRegistro: Timestamp.now()
            };

            await updateDoc(userRef, {
                historialVacaciones: arrayUnion(nuevoRegistro)
            });

            toast.success(`Registrados ${businessDays} días hábiles.`);
            onUpdate();
            setStartDate('');
            setEndDate('');
            setReason('');
        } catch (error) {
            console.error(error);
            toast.error("Error al guardar.");
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (timestamp) => timestamp ? timestamp.toDate().toLocaleDateString('es-MX') : '-';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl h-[80vh] flex flex-col">
                <div className="flex justify-between items-center mb-4">
                    <div>
                        <h3 className="text-lg font-bold">Historial de Vacaciones</h3>
                        <p className="text-sm text-gray-600">{employee.nombreCompleto}</p>
                    </div>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-2xl font-bold">&times;</button>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 flex-grow overflow-hidden">
                    <div className="bg-gray-50 p-4 rounded-lg border overflow-y-auto">
                        <h4 className="font-bold text-sm text-gray-700 mb-3">Agregar Registro Manual</h4>
                        <div className="space-y-3">
                            <div>
                                <label className="block text-xs font-bold text-gray-500">Desde</label>
                                <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full p-2 border rounded-md text-sm"/>
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-gray-500">Hasta</label>
                                <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full p-2 border rounded-md text-sm"/>
                            </div>
                            <div>
                                <label className="block text-xs font-bold text-gray-500">Motivo</label>
                                <input type="text" value={reason} onChange={e => setReason(e.target.value)} className="w-full p-2 border rounded-md text-sm"/>
                            </div>
                            <button onClick={handleAddManual} disabled={loading} className="w-full bg-blue-600 text-white font-bold py-2 rounded-md text-sm hover:bg-blue-700">
                                {loading ? 'Guardando...' : 'Registrar'}
                            </button>
                            <p className="text-xs text-gray-500 mt-2 italic">* Se descontarán solo los días hábiles (L-V).</p>
                        </div>
                    </div>
                    <div className="md:col-span-2 overflow-y-auto pr-2">
                        <h4 className="font-bold text-sm text-gray-700 mb-3">Bitácora de Días Tomados</h4>
                        {history.length === 0 ? (
                            <p className="text-gray-400 text-sm text-center mt-10">Sin registros.</p>
                        ) : (
                            <table className="min-w-full text-sm">
                                <thead className="bg-gray-100 sticky top-0">
                                    <tr>
                                        <th className="px-4 py-2 text-left font-medium text-gray-600">Fechas</th>
                                        <th className="px-4 py-2 text-center font-medium text-gray-600">Días</th>
                                        <th className="px-4 py-2 text-left font-medium text-gray-600">Motivo/Origen</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y">
                                    {history.map((reg, idx) => (
                                        <tr key={idx}>
                                            <td className="px-4 py-2 text-gray-800">
                                                {formatDate(reg.fechaInicio)} - {formatDate(reg.fechaFin)}
                                            </td>
                                            <td className="px-4 py-2 text-center font-bold text-red-600">
                                                -{reg.dias}
                                            </td>
                                            <td className="px-4 py-2 text-gray-600">
                                                {reg.motivo} <span className="text-xs text-gray-400 block">({reg.tipo})</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

//Funcion para agregar y leer dias festivos
const HolidaysManagementModal = ({ holidays, onClose }) => {
    const [newDate, setNewDate] = useState('');
    const [newName, setNewName] = useState('');
    const [newType, setNewType] = useState('Oficial');
    const [newRepeats, setNewRepeats] = useState(true);
    const [loading, setLoading] = useState(false);

    const currentYear = new Date().getFullYear();

    const handleDelete = async (id) => {
        if (!window.confirm("¿Borrar este día festivo?")) return;
        try {
            await deleteDoc(doc(db, "diasFestivos", id));
            toast.success("Eliminado correctamente");
        } catch (e) {
            toast.error("Error al eliminar");
        }
    };

    const handleAdd = async () => {
        if (!newDate || !newName) return toast.warning("Faltan datos");
        setLoading(true);
        try {
            const dateObj = new Date(newDate + 'T12:00:00');
            
            await addDoc(collection(db, "diasFestivos"), {
                fecha: Timestamp.fromDate(dateObj),
                nombre: newName,
                tipo: newType,
                repetirAnualmente: newRepeats
            });
            
            setNewDate('');
            setNewName('');
            setNewType('Oficial');
            setNewRepeats(true);
            
            toast.success("Día festivo agregado");
        } catch (e) {
            console.error(e);
            toast.error("Error al guardar");
        } finally {
            setLoading(false);
        }
    };

    const visibleHolidays = holidays.filter(h => {
        if (h.repetirAnualmente) return true;
        const hDate = h.fecha?.toDate();
        return hDate && hDate.getFullYear() === currentYear;
    }).sort((a, b) => a.fecha.seconds - b.fecha.seconds);

    const formatDateLocal = (timestamp) => {
        if (!timestamp) return '-';
        return timestamp.toDate().toLocaleDateString('es-MX', { 
            day: '2-digit', month: '2-digit', year: 'numeric' 
        });
    };

    const getTypeBadge = (type) => {
        switch(type) {
            case 'Oficial': return <span className="px-2 py-0.5 rounded text-xs font-bold bg-green-100 text-green-800">Oficial (L)</span>;
            case 'Institucional': return <span className="px-2 py-0.5 rounded text-xs font-bold bg-blue-100 text-blue-800">Institucional</span>;
            case 'Excepción': return <span className="px-2 py-0.5 rounded text-xs font-bold bg-yellow-100 text-yellow-800">Excepción</span>;
            default: return <span className="px-2 py-0.5 rounded text-xs font-bold bg-gray-100 text-gray-800">{type}</span>;
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-3xl max-h-[85vh] flex flex-col">
                <div className="flex justify-between items-center mb-4 border-b pb-2">
                    <div>
                        <h3 className="text-lg font-bold text-gray-800">📅 Calendario de Días Festivos</h3>
                        <p className="text-xs text-gray-500">Mostrando festivos del {currentYear} y recurrentes.</p>
                    </div>
                    <button onClick={onClose} className="text-gray-500 hover:text-red-500 text-2xl font-bold">&times;</button>
                </div>

                <div className="bg-blue-50 p-4 rounded-lg mb-4 border border-blue-100">
                    <h4 className="text-xs font-bold text-blue-800 mb-2 uppercase">Agregar Nuevo Día</h4>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-end">
                        
                        <div className="md:col-span-4">
                            <label className="block text-xs font-bold text-gray-600 mb-1">Nombre</label>
                            <input type="text" placeholder="Ej. Navidad" value={newName} onChange={e => setNewName(e.target.value)} className="w-full border rounded p-2 text-xs"/>
                        </div>

                        <div className="md:col-span-3">
                            <label className="block text-xs font-bold text-gray-600 mb-1">Fecha</label>
                            <input type="date" value={newDate} onChange={e => setNewDate(e.target.value)} className="w-full border rounded p-2 text-xs"/>
                        </div>

                        <div className="md:col-span-3">
                            <label className="block text-xs font-bold text-gray-600 mb-1">Tipo</label>
                            <select value={newType} onChange={e => setNewType(e.target.value)} className="w-full border rounded p-2 text-xs bg-white">
                                <option value="Oficial">Oficial (Ley)</option>
                                <option value="Institucional">Institucional</option>
                                <option value="Excepción">Excepción Única</option>
                            </select>
                        </div>

                        <div className="md:col-span-2 flex items-center justify-center pb-2">
                            <label className="flex items-center space-x-2 cursor-pointer">
                                <input 
                                    type="checkbox" 
                                    checked={newRepeats} 
                                    onChange={e => setNewRepeats(e.target.checked)} 
                                    className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                                />
                                <span className="text-xs text-gray-700">¿Repetir?</span>
                            </label>
                        </div>

                        <div className="md:col-span-12 flex justify-end mt-2">
                            <button onClick={handleAdd} disabled={loading} className="bg-blue-600 text-white font-bold py-1 px-6 rounded text-sm hover:bg-blue-700 shadow-sm w-full md:w-auto">
                                {loading ? 'Guardando...' : 'Agregar +'}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="flex-grow overflow-y-auto border rounded-lg">
                    <table className="w-full text-sm text-left text-gray-500">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 sticky top-0">
                            <tr>
                                <th className="px-4 py-3">Fecha</th>
                                <th className="px-4 py-3">Festividad</th>
                                <th className="px-4 py-3 text-center">Tipo</th>
                                <th className="px-4 py-3 text-center">Frecuencia</th>
                                <th className="px-4 py-3 text-right">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visibleHolidays.map((h) => (
                                <tr key={h.id} className="bg-white border-b hover:bg-gray-50">
                                    <td className="px-4 py-3 font-medium text-gray-900 whitespace-nowrap">
                                        {formatDateLocal(h.fecha)}
                                    </td>
                                    <td className="px-4 py-3 font-medium text-gray-800">
                                        {h.nombre}
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        {getTypeBadge(h.tipo || 'Oficial')}
                                    </td>
                                    <td className="px-4 py-3 text-center text-xs">
                                        {h.repetirAnualmente ? (
                                            <span className="text-purple-600 font-semibold flex items-center justify-center gap-1">
                                                🔄 Anual
                                            </span>
                                        ) : (
                                            <span className="text-gray-400">Único</span>
                                        )}
                                    </td>
                                    <td className="px-4 py-3 text-right">
                                        <button onClick={() => handleDelete(h.id)} className="text-red-600 hover:text-red-900 font-semibold text-xs border border-red-200 bg-red-50 px-2 py-1 rounded">
                                            Borrar
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {visibleHolidays.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="text-center p-8 text-gray-400 bg-gray-50">
                                        No hay días festivos configurados para este año.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="mt-2 text-right">
                     <p className="text-xs text-gray-400 italic">* Los días "Oficiales" y "Institucionales" no cuentan como faltas.</p>
                </div>
            </div>
        </div>
    );
};

const EmployeeScheduleModal = ({ employee, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [tolerance, setTolerance] = useState(15);
    
    const defaultDay = { activo: true, entrada: '08:00', salida: '17:00' };
    
    const [schedule, setSchedule] = useState({
        lunes: { ...defaultDay },
        martes: { ...defaultDay },
        miercoles: { ...defaultDay },
        jueves: { ...defaultDay },
        viernes: { ...defaultDay },
        sabado: { ...defaultDay, activo: false, salida: '13:00' },
        domingo: { ...defaultDay, activo: false },
        ...employee.horarioLaboral
    });

    useEffect(() => {
        if (employee.horarioLaboral?.tolerancia) {
            setTolerance(employee.horarioLaboral.tolerancia);
        }
    }, [employee]);

    const daysMap = [
        { key: 'lunes', label: 'Lunes' },
        { key: 'martes', label: 'Martes' },
        { key: 'miercoles', label: 'Miércoles' },
        { key: 'jueves', label: 'Jueves' },
        { key: 'viernes', label: 'Viernes' },
        { key: 'sabado', label: 'Sábado' },
        { key: 'domingo', label: 'Domingo' },
    ];

    const handleDayChange = (dayKey, field, value) => {
        setSchedule(prev => ({
            ...prev,
            [dayKey]: {
                ...prev[dayKey],
                [field]: value
            }
        }));
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            const userRef = doc(db, "usuarios", employee.id);
            const finalSchedule = { 
                ...schedule, 
                tolerancia: parseInt(tolerance) 
            };
            
            await updateDoc(userRef, { horarioLaboral: finalSchedule });
            toast.success("Horario actualizado correctamente");
            onClose();
        } catch (error) {
            console.error(error);
            toast.error("Error al guardar horario");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-xl">
                <div className="flex justify-between items-center mb-6">
                    <div>
                        <h3 className="text-xl font-bold text-gray-800">Horario Laboral</h3>
                        <p className="text-sm text-gray-500">{employee.nombreCompleto}</p>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-3xl">&times;</button>
                </div>

                <div className="mb-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200 flex items-center justify-between">
                    <span className="text-sm font-bold text-yellow-800">⏳ Tolerancia de Retardo (min):</span>
                    <input 
                        type="number" 
                        value={tolerance} 
                        onChange={e => setTolerance(e.target.value)}
                        className="w-20 p-2 border rounded text-center font-bold"
                    />
                </div>

                <div className="space-y-3 mb-6 max-h-[50vh] overflow-y-auto pr-2">
                    {daysMap.map((day) => (
                        <div key={day.key} className={`flex items-center justify-between p-3 rounded-lg border ${schedule[day.key].activo ? 'bg-white border-gray-200' : 'bg-gray-100 border-transparent opacity-75'}`}>
                            
                            <div className="flex items-center space-x-3 w-32">
                                <input 
                                    type="checkbox" 
                                    checked={schedule[day.key].activo} 
                                    onChange={(e) => handleDayChange(day.key, 'activo', e.target.checked)}
                                    className="w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
                                />
                                <span className={`font-semibold ${schedule[day.key].activo ? 'text-gray-800' : 'text-gray-500'}`}>{day.label}</span>
                            </div>

                            <div className="flex items-center space-x-2">
                                <div className="flex flex-col">
                                    <label className="text-[10px] text-gray-400 uppercase">Entrada</label>
                                    <input 
                                        type="time" 
                                        value={schedule[day.key].entrada} 
                                        onChange={(e) => handleDayChange(day.key, 'entrada', e.target.value)}
                                        disabled={!schedule[day.key].activo}
                                        className="border rounded px-2 py-1 text-sm bg-gray-50 disabled:bg-gray-200"
                                    />
                                </div>
                                <span className="text-gray-400 pt-3">-</span>
                                <div className="flex flex-col">
                                    <label className="text-[10px] text-gray-400 uppercase">Salida</label>
                                    <input 
                                        type="time" 
                                        value={schedule[day.key].salida} 
                                        onChange={(e) => handleDayChange(day.key, 'salida', e.target.value)}
                                        disabled={!schedule[day.key].activo}
                                        className="border rounded px-2 py-1 text-sm bg-gray-50 disabled:bg-gray-200"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex justify-end pt-4 border-t">
                    <button onClick={onClose} className="mr-3 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md font-medium">Cancelar</button>
                    <button onClick={handleSave} disabled={loading} className="px-6 py-2 bg-[#b0ef26] hover:bg-[#9ac91e] text-black font-bold rounded-md shadow-sm">
                        {loading ? 'Guardando...' : 'Guardar Horario'}
                    </button>
                </div>
            </div>
        </div>
    );
};